exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-order-info[data-v-4b1f27b8]{width:100%}.order-info-title[data-v-4b1f27b8]{background-color:#eee}.delivery-order-info td[data-v-4b1f27b8]{text-align:center!important;border:1px solid #e0d9d9;padding:6px;vertical-align:middle!important}", ""]);

// exports
